<button class="btn-export" mat-raised-button color="accent" [matMenuTriggerFor]="appMenu">
  {{'Esportazione' | translate}}
</button>

<mat-menu #appMenu="matMenu">
  @for (btn of viewConfig.exportBtnActions; track btn) {
    <button
      mat-menu-item
      class='mr-4'
      [matTooltip]='btn.tooltip'
      (click)='downloadFile(btn)'>
      @if (btn.buttonIcon) {
        <mat-icon>{{btn.buttonIcon}}</mat-icon>
      }
      @if (btn.buttonText) {
        <span [class.ml-4]='btn.buttonIcon'>{{btn.buttonText}}</span>
      }
    </button>
  }
</mat-menu>